import { useState } from 'react'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { $userSteamAuthUrl } from '@/entities/user'
import { goToMain, goToTon } from '@/app/routing/events'

import { useStyles } from './styles'
import { AppButton } from '@/shared/ui/button'
import { GamedDataUsage } from '@/shared/ui/gamedDataUsage'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { Icon } from '@/shared/ui/icon'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { useTonConnectUI } from '@tonconnect/ui-react'

export const SteamConnetPageView = () => {
  useHideNav()

  const { classes } = useStyles()
  const loginPage = useUnit($userSteamAuthUrl)
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.main

  const [isOpeningSteam, setIsOpeningSteam] = useState(false)
  const [isDataInfoOpen, setDataInfoView] = useState(false)
  const walletConnected = useTonConnectUI()[0].connected

  function handleConnectSteam() {
    setIsOpeningSteam(true)
    window.location.href = loginPage!
    setTimeout(() => {
      setIsOpeningSteam(false)
    }, 3000)
    // timeout is for the case when user has slow internet connection
  }

  function handleTonConnect() {
    if (walletConnected) {
      goToMain()
      return
    }
    goToTon()
  }

  if (isDataInfoOpen) {
    return (
      <GamedDataUsage
        onClick={() => {
          setDataInfoView(false)
        }}
      />
    )
  }
  return (
    <div className={classes.rootWrapper}>
      <img
        src="/assets/backgrounds/StartBG.webp"
        alt=""
        className={classes.startScreenImg}
      />

      <BackgroundShading
        width="100%"
        height="350px"
        bottom="0"
        startColor="#00000000"
        endColor="#000000"
      />

      <div className={classes.root}>
        <div className={classes.voidInfoWrapper}>
          <span className={classes.infoText}>
            <Icon view="loginInfo" />
            &nbsp;
            {texts.steam_modal_content}
          </span>
        </div>
        <div className={classes.contentWrapper}>
          <img
            className={classes.void}
            src="/assets/backgrounds/void.webp"
            alt=""
          />
          <div className={classes.contentRoot}>
            <div className={classes.headerWrapper}>
              <Icon
                view="steam"
                width={24}
              />
              <span>{texts.modal_title}</span>
            </div>
            <div className={classes.paragraphs}>
              <span>{texts.paragraph1}</span>
              <span>{texts.paragraph2}</span>
              <span
                onClick={() => setDataInfoView(true)}
                className={classes.whatData}
              >
                {texts.whatDataLink}
              </span>
            </div>
            <div className={classes.buttonsContainer}>
              <AppButton
                fullWidth
                className={classes.connectButton}
                isLoading={isOpeningSteam}
                onClick={handleConnectSteam}
              >
                <span>{texts.connect_steam}</span>
              </AppButton>
              <AppButton
                fullWidth
                className={classes.noSteamButton}
                onClick={handleTonConnect}
              >
                {texts.no_steam_account}
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
